import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { BirthplaceInput } from '../../../BasePersonInputs/Birthplace/BirthplaceInput';

export function BirthplaceField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={BirthplaceInput}
      label='Vorname'
    />
  );
}
